'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchPrV2AvailableLabels } from './fetch-pr-v2';
import { prV2AvailableLabelsQueryKey } from './query-keys';

// Labels change rarely. A minute keeps reopening the picker instant while still picking up a
// label someone just created on GitHub.
const AVAILABLE_LABELS_STALE_TIME_MS = 60_000;

/** The labels the pull request's repository offers, for the label picker. */
export function usePrV2AvailableLabels(owner, repo, number, options) {
  const $ = _c(11);
  let t0;
  if ($[0] !== owner || $[1] !== repo) {
    t0 = prV2AvailableLabelsQueryKey(owner, repo);
    $[0] = owner;
    $[1] = repo;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== number || $[4] !== owner || $[5] !== repo) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchPrV2AvailableLabels(owner, repo, number, signal);
    };
    $[3] = number;
    $[4] = owner;
    $[5] = repo;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = Boolean(owner && repo && number) && options.enabled;
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: AVAILABLE_LABELS_STALE_TIME_MS,
      refetchOnWindowFocus: false
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useQuery(t3);
}